
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { supabase } from "@/integrations/supabase/client";

export const useTagData = () => {
  // Tags data
  const { data: tags = [] } = useQuery({
    queryKey: ['networkViewTags'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('tags')
        .select('id, name, color');
      
      if (error) {
        console.error('Error fetching tags:', error);
        return [];
      }
      
      return data;
    },
    staleTime: 60000,
  });

  const tagColorMap = useMemo(() => {
    const map: Record<string, string> = {};
    tags.forEach((tag: any) => {
      map[tag.id] = tag.color || "#8E9196";
    });
    return map;
  }, [tags]);

  const { data: contentTags = [] } = useQuery({
    queryKey: ['networkViewContentTags'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('content_tags')
        .select('content_id, tag_id');
      
      if (error) {
        console.error('Error fetching content tags:', error);
        return [];
      }
      
      return data;
    },
    staleTime: 60000,
  });

  const contentToTagsMap = useMemo(() => {
    const map: Record<string, string[]> = {};
    contentTags.forEach((relation: any) => {
      if (!map[relation.content_id]) {
        map[relation.content_id] = [];
      }
      map[relation.content_id].push(relation.tag_id);
    });
    return map;
  }, [contentTags]);

  return {
    tags,
    tagColorMap,
    contentToTagsMap
  };
};
